import {
  Box,
  Button,
  FormControlLabel,
  Link,
  Modal,
  Radio,
  RadioGroup,
} from "@mui/material";
import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import DatePicker from "../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";
import "../PreviewPage/PreviewPage.scss";
import {
  validateEmail,
  validateMobileNumber,
} from "../../../Supporting files/HelpingFunction";

interface Props {
  open_status: boolean;
  value_update: Function;
  attrName: any;
}

const PreviewPage: React.FC<Props> = ({
  open_status,
  value_update,
  attrName,
}) => {
  const [client, setClient] = React.useState("");
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [previewStatus, setPreviewStatus] = React.useState(false);

  const [pageStatus, setPageStatus] = React.useState<number>(1);

  const changePageStatus = (status: Boolean) => {
    if (status == true) {
      if (pageStatus < 4) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };
  const navigate = useNavigate();
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);
  const [title, setTitle] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [middleName, setMiddleName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [mobileNumber, setMobileNumber] = React.useState("");
  const [officeEmail, setOfficeEmail] = React.useState("");
  const [officePhone, setOfficePhone] = React.useState("");
  const [Department, setDepartment] = React.useState("");
  const [Designation, setDesignation] = React.useState("");
  const [organizationName, setOrganizationName] = React.useState("");
  const [industry, setIndustry] = React.useState("");
  const [subindustry, setSubIndustry] = React.useState("");
  const [streetName, setStreetName] = React.useState("");
  const [areaName, setAreaName] = React.useState("");
  const [city, setCity] = React.useState("");
  const [zipcode, setZipcode] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [state, setState] = React.useState("");
  const [streetNameOrg, setStreetNameOrg] = React.useState("");
  const [areaNameOrg, setAreaNameOrg] = React.useState("");
  const [cityOrg, setCityOrg] = React.useState("");
  const [zipcodeOrg, setZipcodeOrg] = React.useState("");
  const [countryOrg, setCountryOrg] = React.useState("");
  const [stateOrg, setStateOrg] = React.useState("");
  const [spoc, setSpoc] = React.useState("");
  // const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [Dob, setDob] = React.useState<Date | null>(null);
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const [sectionStatus, SetSectionStatus] = React.useState<string>(
    "personalDetailsSection"
  );
  const [subSection, setSubSection] = React.useState<string>("basics");
  const [toggle, setToggle] = React.useState(true);

  const title_data = [
    { key: "Mr.", value: "Mr." },
    { key: "Mrs.", value: "Mrs." },
    { key: "Ms.", value: "Ms." },
  ];

  const gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
    { key: "Other", value: "Other" },
  ];
  const Department_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const state_data = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Punjab", value: "Punjab" },
    { label: "Haryana", value: "Haryana" },
    { label: "Kerla", value: "Kerla" },
    { label: "Delhi", value: "Delhi" },
  ];
  const city_data = [
    { label: "Ambala", value: "Ambala" },
    { label: "Nanital", value: "Nanital" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Jaipur", value: "Jaipur" },
    { label: " New Delhi", value: "New Delhi" },
  ];

  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];

  const Designation_data = [
    {
      label: "Associate Frontend Developer",
      value: "Associate Frontend Developer",
    },
    { label: "Frontend Developer", value: "Frontend Developer" },
    {
      label: "Senior Frontend Developer",
      value: "Senior Frontend Developer",
    },
    {
      label: "Associate Software Engineer",
      value: "Associate Software Engineer",
    },
    { label: "Software Engineer", value: "Software Engineer" },
    { label: "Associate Hr", value: "Associate Hr" },
    { label: "Hr Executive", value: "Hr Executive" },
  ];
  const industry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const subindustry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const updateMasterState = (attrName: any, value: any) => {
    if (attrName === "notes_new_data") {
      setNotesData((notesData) => [
        ...notesData,
        { name: "Umesh", date: new Date(), description: value },
      ]);
    } else {
      attrName(value);
    }
  };

  const clientid_data = [
    { label: "CLT012 - Evervent", value: "CLT012 - Evervent" },
    { label: "CLT013 - Evervent", value: "CLT013 - Evervent" },
    { label: "CLT014 - Evervent", value: "CLT014 - Evervent" },
    { label: "CLT015 - Evervent", value: "CLT015 - Evervent" },
  ];

  const handleClicked = () => {
    setToggle(true);
  };
  const handleClick = () => {
    setToggle(false);
  };

  const validate_form = () => {
    let warn_title = title.toString().length == 0 ? true : false;
    let warn_first_name = firstName.toString().length == 0 ? true : false;
    let warn_middle_name = middleName.toString().length == 0 ? true : false;
    let warn_last_name = lastName.toString().length == 0 ? true : false;
    let warn_org_email = !validateEmail(email);
    let warn_phone = !validateMobileNumber(mobileNumber);

    if (
      warn_title == false &&
      warn_first_name == false &&
      warn_middle_name == false &&
      warn_last_name == false &&
      warn_org_email == false &&
      warn_phone == false
    ) {
    }
  };
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  // for scrolling
  const personalDetailsSection = useRef(null);
  const organizationDetailsSection = useRef(null);

  const basics = useRef(null);
  const professional = useRef(null);
  const personal = useRef(null);
  const organizationinfo = useRef(null);
  const officeaddress = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Modal
      open={open_status}
      className="preview_modalWrapper"
      onClose={() => {
        value_update(attrName, false);
      }}
    >
      <Box className="modalInner full-width">
        <Grid container spacing={2} alignItems="center">
          <Grid xs={8}>
            <h2 className="popup-heading">Contacts - Preview</h2>
          </Grid>
          <Grid xs={4} className="text-right">
            <Link
              className="preview_close_button"
              onClick={() => {
                value_update(attrName, false);
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid xs={12}>
            <Grid container spacing={3}>
              <Grid xs className="leftSection pl-0">
                <Link
                  className={
                    sectionStatus === "personalDetailsSection"
                      ? "active sectionLink personalDetailsSection"
                      : "sectionLink personalDetailsSection"
                  }
                  onClick={() => {
                    handleClicks(sectionStatus);
                    scrollToSection(personalDetailsSection);
                    SetSectionStatus("personalDetailsSection");
                  }}
                >
                  <span> Personal Details</span>
                </Link>
                <ul className="accordion_list">
                  <li>
                    <Link
                      className={
                        subSection === "basics"
                          ? "inner_link active basics"
                          : "inner_link  basics"
                      }
                      onClick={() => {
                        handleClicks(subSection);
                        scrollToSection(basics);
                        setSubSection("basics");
                      }}
                    >
                      Basic Info
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        subSection === "professional"
                          ? "inner_link active professional"
                          : "inner_link professional"
                      }
                      onClick={() => {
                        setSubSection("professional");
                        handleClicks(subSection);
                        scrollToSection(professional);
                      }}
                    >
                      Professional Details
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        subSection === "personal"
                          ? "inner_link active personal"
                          : "inner_link personal"
                      }
                      onClick={() => {
                        setSubSection("personal");
                        handleClicks(subSection);
                        scrollToSection(personal);
                      }}
                    >
                      Personal Address
                    </Link>
                  </li>
                </ul>
                <Link
                  className={
                    sectionStatus === "organizationDetailsSection"
                      ? "active sectionLink organizationDetailsSection"
                      : "sectionLink organizationDetailsSection"
                  }
                  onClick={() => {
                    handleClicks(sectionStatus);
                    scrollToSection(organizationDetailsSection);
                    SetSectionStatus("organizationDetailsSection");
                  }}
                >
                  <span>Organization Details </span>
                </Link>
                <ul className="accordion_list">
                  <li>
                    <Link
                      className={
                        subSection === "organizationinfo"
                          ? "inner_link active organizationinfo"
                          : "inner_link organizationinfo"
                      }
                      onClick={() => {
                        setSubSection("organizationinfo");
                        handleClicks(subSection);
                        scrollToSection(organizationinfo);
                      }}
                    >
                      Organization Info
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={
                        subSection === "officeaddress"
                          ? "inner_link active officeaddress"
                          : "inner_link officeaddress"
                      }
                      onClick={() => {
                        setSubSection("officeaddress");
                        handleClicks(subSection);
                        scrollToSection(officeaddress);
                      }}
                    >
                      Office Address
                    </Link>
                  </li>
                </ul>
              </Grid>
              <Grid xs className="rightSection">
                <Box className="detailSection" ref={personalDetailsSection}>
                  <div ref={basics}>
                    <div className="sectionTitle">
                      <h4>Personal Details</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <h5 className="subHeading">Basic Info</h5>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid xs={3} md={2} lg={2} xl={1}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Title"
                          value={title}
                          attrName={setTitle}
                          value_update={updateMasterState}
                          dropdown_data={title_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"First Name"}
                          value={firstName}
                          attrName={setFirstName}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Last Name"}
                          value={lastName}
                          attrName={setLastName}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid sm={4} md={4} lg={3} xl={2}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Gender"
                          value={gender}
                          attrName={setGender}
                          value_update={updateMasterState}
                          dropdown_data={gender_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={2}>
                        <DatePicker
                          class_name="inputField"
                          title="Date of Birth"
                          value={Dob}
                          attrName={setDob}
                          value_update={updateMasterState}
                          error_message="Please enter Date of Birth"
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={2}>
                        <RKTextField
                          class_name="inputField"
                          title={"Mobile"}
                          value={mobileNumber}
                          attrName={setMobileNumber}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={3} xl={2}>
                        <RKTextField
                          class_name="inputField"
                          title={"Email"}
                          value={email}
                          attrName={setEmail}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </div>
                  <div ref={professional}>
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <h5 className="subHeading">Professional Details</h5>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid sm={6} md={5} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Office Phone"}
                          value={officePhone}
                          attrName={setOfficePhone}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={6} md={5} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Office Email"}
                          value={officeEmail}
                          attrName={setOfficeEmail}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid sm={6} md={5} lg={3} xl={3}>
                        <SearchDropdown
                          class_name="inputField"
                          title="Department"
                          value={Department}
                          attrName={setDepartment}
                          value_update={updateMasterState}
                          data={Department_data}
                          warn_status={false}
                          error_message="Please select client"
                        />
                      </Grid>
                      <Grid sm={6} md={5} lg={3} xl={3}>
                        <SearchDropdown
                          class_name="inputField"
                          title="Designation"
                          value={Designation}
                          attrName={setDesignation}
                          value_update={updateMasterState}
                          data={Designation_data}
                          warn_status={false}
                          error_message="Please select client"
                        />
                      </Grid>
                    </Grid>
                  </div>
                  <div ref={personal}>
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <h5 className="subHeading">Personal Address</h5>
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid sm={6} md={6} lg={4} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Building/Street Name"}
                          value={streetNameOrg}
                          attrName={setStreetNameOrg}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={6} md={6} lg={4} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Area Name"}
                          value={areaNameOrg}
                          attrName={setAreaNameOrg}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <SearchDropdown
                          class_name="inputField"
                          title="Country"
                          value={country}
                          attrName={setCountry}
                          value_update={updateMasterState}
                          data={country_data}
                          warn_status={false}
                          error_message="Please select client"
                        />
                      </Grid>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <SearchDropdown
                          class_name="inputField"
                          title="State"
                          value={state}
                          attrName={setState}
                          value_update={updateMasterState}
                          data={state_data}
                          warn_status={false}
                          error_message="Please select client"
                        />
                      </Grid>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <SearchDropdown
                          class_name="inputField"
                          title="City"
                          value={city}
                          attrName={setCity}
                          value_update={updateMasterState}
                          data={city_data}
                          warn_status={false}
                          error_message="Please select client"
                        />
                      </Grid>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Zipcode"}
                          value={zipcode}
                          attrName={setZipcode}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </div>
                </Box>
                <Box className="detailSection" ref={organizationDetailsSection}>
                  <div className="sectionTitle">
                    <h4>Organization Details </h4>
                  </div>
                  <div ref={organizationinfo}>
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <h5 className="subHeading">Organization Info</h5>
                      </Grid>
                      <Box className="  ml-3">
                        <Grid container spacing={3}>
                          <Grid xs={12} className="radio_group mt-3 mb-7">
                            <>
                              <RadioGroup row defaultValue="new">
                                <FormControlLabel
                                  value="existing"
                                  control={<Radio />}
                                  label="Existing Client"
                                  onClick={handleClick}
                                />
                                <FormControlLabel
                                  // checked
                                  value="new"
                                  control={<Radio />}
                                  label="New Client"
                                  onClick={handleClicked}
                                />
                              </RadioGroup>
                            </>
                          </Grid>
                        </Grid>
                      </Box>
                      <Grid xs={12} style={{ padding: "0" }}>
                        {toggle == true ? (
                          <>
                            <Grid container spacing={3}>
                              <Grid sm={8} md={6} lg={6}>
                                <RKTextField
                                  class_name="inputField"
                                  title={"Organization"}
                                  value={organizationName}
                                  attrName={setOrganizationName}
                                  value_update={updateMasterState}
                                  warn_status={false}
                                />
                              </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                              <Grid sm={6} md={6} lg={6}>
                                <SearchDropdown
                                  class_name="inputField"
                                  title="Industry"
                                  value={industry}
                                  attrName={setIndustry}
                                  value_update={updateMasterState}
                                  data={industry_data}
                                  warn_status={false}
                                  error_message="Please select client"
                                />
                              </Grid>
                              <Grid sm={6} md={6} lg={6}>
                                <SearchDropdown
                                  class_name="inputField"
                                  title="Sub-Industry"
                                  value={subindustry}
                                  attrName={setSubIndustry}
                                  value_update={updateMasterState}
                                  data={subindustry_data}
                                  warn_status={false}
                                  error_message="Please select client"
                                />
                              </Grid>
                            </Grid>
                          </>
                        ) : null}
                      </Grid>
                      <Grid container spacing={3}>
                        {toggle == false ? (
                          <>
                            <Grid xs={12} lg={6}>
                              <SearchDropdown
                                class_name="inputField"
                                title="Search Client ID"
                                value={spoc}
                                attrName={setSpoc}
                                value_update={updateMasterState}
                                data={clientid_data}
                                warn_status={false}
                                error_message="Please select client"
                              />
                            </Grid>
                            <Grid lg={12}>
                              <Grid container className="px-0">
                                <Grid xs={4}>
                                  <div className="existing_client_logo">
                                    <img
                                      src="./images/evervent-logo.svg"
                                      alt="digit"
                                      className="company_logo"
                                    />
                                  </div>
                                </Grid>
                                <Grid xs={8}>
                                  <p className="company_details">
                                    Evervent
                                    <span>
                                      Information Technology - Software
                                    </span>
                                  </p>
                                </Grid>
                                <Grid xs={6} lg={4}>
                                  <Link
                                    className="email_list"
                                    href="mailto:email@example.com"
                                  >
                                    example@domain.com
                                  </Link>
                                </Grid>
                                <Grid xs={6} lg={4}>
                                  <Link
                                    className="email_list"
                                    href=""
                                    target="_blank"
                                  >
                                    www.example.com
                                  </Link>
                                </Grid>

                                <Grid xs={6} lg={4}>
                                  <p className="contactNumber">
                                    +91 9876543210
                                  </p>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        ) : null}
                      </Grid>
                    </Grid>
                  </div>

                  <div ref={officeaddress}>
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <h5 className="subHeading">Office Address</h5>
                      </Grid>
                    </Grid>

                    <Grid container spacing={3}>
                      <Grid sm={6} md={6} lg={4} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Building/Street Name"}
                          value={streetNameOrg}
                          attrName={setStreetNameOrg}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={6} md={6} lg={4} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Area Name"}
                          value={areaNameOrg}
                          attrName={setAreaNameOrg}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <SearchDropdown
                          class_name="inputField"
                          title="Country"
                          value={countryOrg}
                          attrName={setCountryOrg}
                          value_update={updateMasterState}
                          data={country_data}
                          warn_status={false}
                          error_message="Please select client"
                        />
                      </Grid>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <SearchDropdown
                          class_name="inputField"
                          title="State"
                          value={stateOrg}
                          attrName={setStateOrg}
                          value_update={updateMasterState}
                          data={state_data}
                          warn_status={false}
                          error_message="Please select client"
                        />
                      </Grid>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <SearchDropdown
                          class_name="inputField"
                          title="City"
                          value={cityOrg}
                          attrName={setCityOrg}
                          value_update={updateMasterState}
                          data={city_data}
                          warn_status={false}
                          error_message="Please select client"
                        />
                      </Grid>
                      <Grid sm={6} md={4} lg={3} xl={3}>
                        <RKTextField
                          class_name="inputField"
                          title={"Zipcode"}
                          value={zipcodeOrg}
                          attrName={setZipcodeOrg}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default PreviewPage;
